<script setup lang="ts">

import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'
import VersionDetail from '@/modules/setting/views/VersionDetail.vue'
</script>

<template>
  <dashboard-layout currentRoute="system/version" page-title="Tạo phiên bản">
    <VersionDetail id="0" action="create"/>
  </dashboard-layout>
</template>

<style scoped>

</style>
